import { PRODUCT_LIST_SUCCESS, PRODUCT_LIST_FAIL } from '../constants/productConstants'
import axios from 'axios'


export const listproducts = () => async (dispatch) => {
    const {data} = await axios.get('/productsdata.json')

    try {
        dispatch({ type: PRODUCT_LIST_SUCCESS, payload : data.productdata })
    } catch (error) {
        dispatch({ type: PRODUCT_LIST_FAIL, error : error })
    }

}

